import moment from 'moment';

const parseIsoDate = (isoString) => {
  return moment(isoString).toDate();
};

export default parseIsoDate;
